<template>
  <div class="mobile-warning">
    <div class="mobile-warning__card">
      <i class="pi pi-desktop mobile-warning__icon" aria-hidden="true" />
      <h1 class="mobile-warning__title">{{ t("MOBILE_WARNING.TITLE") }}</h1>
      <p class="mobile-warning__text">{{ t("MOBILE_WARNING.BODY") }}</p>
      <p class="mobile-warning__hint">{{ t("MOBILE_WARNING.HINT") }}</p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<style scoped>
.mobile-warning {
  display: none;
  min-height: 100dvh;
  padding: 24px;
  place-items: center;
  background: #f8fafb;
}

.mobile-warning__card {
  width: min(560px, 100%);
  padding: 28px;
  border-radius: 16px;
  border: 1px solid #dbe7df;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.mobile-warning__icon {
  font-size: 2rem;
  color: #2f8f4e;
}

.mobile-warning__title {
  margin: 12px 0 8px;
  font-size: 1.5rem;
  line-height: 1.25;
}

.mobile-warning__text {
  margin: 0;
  color: #334155;
  line-height: 1.5;
}

.mobile-warning__hint {
  margin: 12px 0 0;
  color: #64748b;
  font-size: 0.95rem;
}

@media (max-width: 767px) {
  .mobile-warning {
    display: grid;
    position: fixed;
    inset: 0;
    z-index: 2000;
  }
}

@media print {
  .mobile-warning {
    display: none !important;
  }
}
</style>
